import { render, staticRenderFns } from "./CRMMigrationProposal.vue?vue&type=template&id=073d46c7&scoped=true&"
import script from "./CRMMigrationProposal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CRMMigrationProposal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CRMMigrationProposal.vue?vue&type=style&index=0&id=073d46c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d46c7",
  null
  
)

export default component.exports